import * as Msal from 'msal';
import { msalConfig, loginRequest } from './authConfig.js';
import GraphService from './graph.service.js';
export default class AuthService {
  constructor() {
    this.app = new Msal.UserAgentApplication(msalConfig);
    this.graphService = new GraphService();
  }


  userProfile() {


    this.getToken().then(
      token => {
        this.graphService.getUserInfo(token).then(
          data => {
            return data;
          },
          error => {
            console.error(error);
            return null;
          }
        );
      },
      error => {
        console.error(error);
        return null;
      }
    );
  }

  login() {

    return this.app.loginPopup(loginRequest).then(
      idToken => {

        //console.log("id_token acquired at: " + new Date().toString());
        //console.log(idToken);
        const user = this.app.getAccount();
        if (user) {
          return user;
        } else {

          return null;
        }
      },
      () => {
        return null;
      }
    );
  }

  logout() {
    this.app.logout();
  }

  getToken() {
    return this.app.acquireTokenSilent(loginRequest).then(
      accessToken => {
        return accessToken;
      },
      error => {
        //console.log(error);
        console.log("silent token acquisition fails. acquiring token using popup");
        return this.app
          .acquireTokenPopup(loginRequest)
          .then(
            accessToken => {
              return accessToken;
            },
            err => {
              console.error(err);
            }
          );
      }
    );
  }
  
}
